import React from 'react';

type ReceiptRowV9Props = {
    value?: string | React.JSX.Element | Function,
    subvalue?: string | React.JSX.Element | Function,
    classes?: string[]
}

const ReceiptRowV9 = (props: ReceiptRowV9Props) => {

    let classes = ['receipt-row-v9'];
    if (Array.isArray(props.classes)) {
        classes.push(...props.classes);
    }

    const renderValue = (): string | React.JSX.Element => {
        if (props.value === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v9__value">
                {(typeof props.value === 'function') ? props.value() : props.value}
            </div>
        );
    }

    const renderSubvalue = (): string | React.JSX.Element => {
        if (props.subvalue === undefined) {
            return <></>;
        }

        return (
            <div className="receipt-row-v9__subvalue">
                {(typeof props.subvalue === 'function') ? props.subvalue() : props.subvalue}
            </div>
        );
    }

    return (
        <div className={classes.join(' ')}>
            {renderValue()}
            {renderSubvalue()}
        </div>
    );

}

export default ReceiptRowV9;